import React from "react";
import { OrderModalButtonProps } from "../../types/order-modal-button";
import { publishToOrderModal } from "../../util/call-order-modal";
import BasketIcon from "../../assets/basket-icon";
import "./order-modal-button.scss";

const OrderModalButton = (props: OrderModalButtonProps) => {
  const buttonTabNavAttribute = { focusable: true };

  const handleClick = () =>
    publishToOrderModal(
      props.article,
      props.itemOrigin,
      props.productRecoModel,
      props.pageLocation
    );

  return (
    <div className="order-modal-button-container">
      <button
        className="prs-button order-modal"
        data-testid={`prs-button-order-modal-${props.article.slot}`}
        data-semantic-id="product-recommendation-tile"
        data-product-recommendation-tile-index={props.article.slot}
        data-product-recommendation-fragment={props.dataFragmentName}
        data-product-recommendation-model={props.productRecoModel}
        onClick={handleClick}
        {...buttonTabNavAttribute}
      >
        <BasketIcon />
        <span className="call-to-action">{props.l10n.addToCart}</span>
      </button>
    </div>
  );
};

export default OrderModalButton;
